import { useMemo, useCallback } from 'react';
import { usePlayerMaxTimeShift, usePlayerActions } from '@dtvgo/player-context';
import { useGetSync } from '@dtvgo/react-utils';
import 'react/jsx-runtime';
import { useLiveDuration, useLiveEdgeProgress, useLiveProgress } from './LiveInfoProvider/hooks.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import './LiveInfoProvider/contexts.js';

function useLiveProgressBarInfo() {
  var duration = useLiveDuration();
  var liveEdgeProgress = useLiveEdgeProgress();
  var progress = useLiveProgress();
  var maxTimeShift = usePlayerMaxTimeShift();
  var seekable = useMemo(function () {
    return {
      start: Math.max(0, liveEdgeProgress + maxTimeShift),
      end: Math.min(duration, liveEdgeProgress)
    };
  }, [duration, liveEdgeProgress, maxTimeShift]);
  var getLiveEdgeProgress = useGetSync(liveEdgeProgress);
  var _usePlayerActions = usePlayerActions(),
    seek = _usePlayerActions.seek;
  var handleSeek = useCallback(function (value) {
    seek(value - getLiveEdgeProgress());
  }, [getLiveEdgeProgress, seek]);
  return {
    duration: duration,
    progress: progress,
    seekable: seekable,
    handleSeek: handleSeek
  };
}

export { useLiveProgressBarInfo };
//# sourceMappingURL=useLiveProgressBarInfo.js.map
